import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed left-0 top-0 w-full h-full bg-black-900 bg-opacity-30"
}
const _hoisted_2 = { class: "relative xl:w-2/3 mx-auto bg-primary-50 py-6 pl-8 pr-18" }
const _hoisted_3 = { class: "text-para-s text-black-900" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_with_top_margin_content = _resolveComponent("with-top-margin-content")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        ($data.bannerModel)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              ref: "languageHint",
              class: _normalizeClass(["hidden lg:block absolute inset-x-0 text-right bg-black-50 text-black-900 py-4 px-10 xl:px-20", _ctx.subsiteNavExists ? 'top-[calc(100%_+_3.5rem)]' : 'top-full'])
            }, [
              _createElementVNode("span", null, _toDisplayString($props.hint), 1)
            ], 2))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        ($props.showLanguageBanner)
          ? _renderSlot(_ctx.$slots, "mobile-language-banner", {
              key: 0,
              subsiteNavExists: _ctx.subsiteNavExists
            })
          : _createCommentVNode("", true)
      ]),
      _: 3
    }),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        ($data.noContentModel)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_component_with_top_margin_content, {
                class: "container",
                sm: 4,
                md: 6,
                lg: 8,
                xl: 8
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", {
                      class: "absolute top-0 right-0 flex justify-center items-center w-10 h-10 bg-primary-500 hover:bg-black-900 cursor-pointer",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => ($data.noContentModel = false))
                    }, [
                      _createVNode(_component_Icon, {
                        name: "close",
                        class: "w-4 h-4 text-white stroke-current"
                      })
                    ]),
                    _createElementVNode("span", _hoisted_3, _toDisplayString($options.noContentText), 1)
                  ])
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}